import React from "react";

export default function Terms() {
    return (
        <div className="bg-white py-20" data-testid="terms-page">
            <div className="max-w-3xl mx-auto px-6 sm:px-8">
                <div className="uppercase tracking-[0.25em] text-xs font-semibold text-slate-700 mb-3">Legal</div>
                <h1 className="font-serif text-4xl sm:text-5xl text-navy-900">Terms of Service</h1>
                <p className="text-slate-600 mt-6 text-lg leading-relaxed">
                    By submitting information through AnnuityReviewPro, you consent to be contacted by a licensed insurance professional about your annuity review.
                </p>
                <h2 className="font-serif text-2xl text-navy-900 mt-10">Use of this service</h2>
                <p className="text-slate-600 mt-3 leading-relaxed">
                    The information provided through the scorecard and any review is informational. It is not a solicitation to buy or sell any specific product, and it is not legal or tax advice.
                </p>
                <h2 className="font-serif text-2xl text-navy-900 mt-10">No guarantees</h2>
                <p className="text-slate-600 mt-3 leading-relaxed">
                    Annuity products are issued by insurance companies and are subject to the terms of the actual contract. Any opinions are based on the information you provide.
                </p>
                <h2 className="font-serif text-2xl text-navy-900 mt-10">Disclaimer</h2>
                <p className="text-slate-600 mt-3 leading-relaxed">
                    We do not provide tax or legal advice. Recommendations are based on information provided and a full suitability review. Results may vary.
                </p>
            </div>
        </div>
    );
}
